// "ResizeObserver loop completed with undelivered notifications" (and the older
// "ResizeObserver loop limit exceeded") is a benign browser quirk: when an
// observer callback changes layout, the spec simply defers the remaining
// notifications to the next frame. It has no functional impact, but it surfaces
// as a window `error` event that trips dev error overlays and error boundaries.
// Swallow exactly these two messages — nothing else.

if (typeof window !== "undefined") {
  window.addEventListener(
    "error",
    (e) => {
      // Match both "…loop limit exceeded" and "…loop completed with undelivered
      // notifications" (with or without trailing period, across browsers).
      if (typeof e.message === "string" && e.message.startsWith("ResizeObserver loop")) {
        e.stopImmediatePropagation();
        e.preventDefault();
      }
    },
    true, // capture: run before the dev-overlay / framework handlers
  );
}
